import { Component } from '@angular/core';
import { AuthService } from '../../Services/auth.service';

@Component({
  selector: 'app-business-leads',
  standalone: false,
  templateUrl: './business-leads.component.html',
  styleUrl: './business-leads.component.css'
})
export class BusinessLeadsComponent {
 menuItems = [
  { path: "AIFilterNews", label: "MENU.AI_FILTERED_NEWS" },
  { path: "BusinessOporunity", label: "MENU.TAILORED_BUSINESS_OPPORTUNITIES" },   
  { path: "NetowringSuggections", label: "MENU.NETWORKING_SUGGESTIONS" },   
  ];
userRole:string
constructor(private auth:AuthService){
    this.userRole=this.auth.getRoles();
}

getIcon(path: string): string {
  const iconMap: { [key: string]: string } = {
    "AIFilterNews": "fas fa-newspaper",  
    "BusinessOporunity": "fas fa-lightbulb",
    "NetowringSuggections": "fas fa-users", 
  };
  return iconMap[path] || "bi bi-circle"; 
}
}
